// extracted by mini-css-extract-plugin
module.exports = {"base":"userReviews_base__cWcO7","wrapper":"userReviews_wrapper__OB4Gh","left":"userReviews_left__D1TqV","sticky":"userReviews_sticky__fANe8","right":"userReviews_right__HL4D9"};